<template>
  <section class="block space-y-1 text-center">
    <div class="flex space-x-1">
      <button
        class="bg-ontick-graphite-500 rounded px-3 py-1.5 text-base font-medium"
        @click="previousPage"
      >
        <svg
          width="11"
          height="16"
          viewBox="0 0 11 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M9.91963 0.469045C10.22 0.769465 10.3887 1.17687 10.3887 1.60166C10.3887 2.02645 10.22 2.43386 9.91963 2.73428L4.64424 8.00967L9.91963 13.2851C10.2114 13.5872 10.3729 13.9919 10.3693 14.4119C10.3656 14.832 10.1971 15.2338 9.90012 15.5308C9.60309 15.8278 9.20129 15.9963 8.78125 15.9999C8.36121 16.0036 7.95654 15.8421 7.6544 15.5503L1.24639 9.14229C0.94606 8.84187 0.777344 8.43447 0.777344 8.00967C0.777344 7.58488 0.94606 7.17748 1.24639 6.87706L7.6544 0.469045C7.95482 0.168716 8.36222 0 8.78702 0C9.21181 0 9.61921 0.168716 9.91963 0.469045Z"
            :fill="currentPage > 1 ? '#0694E6' : '#6c737f'"
          />
        </svg>
      </button>
      <button
        class="bg-ontick-blue-900 rounded px-4 py-1.5 text-base font-medium"
      >
        {{ currentPage }}
      </button>
      <button
        class="bg-ontick-graphite-500 rounded px-3 py-1.5 text-base font-medium"
        @click="nextPage"
      >
        <svg
          width="14"
          height="20"
          viewBox="0 0 14 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M2.85771 17.531C2.55738 17.2305 2.38867 16.8231 2.38867 16.3983C2.38867 15.9735 2.55738 15.5661 2.85771 15.2657L8.13311 9.99033L2.85771 4.71493C2.56589 4.41279 2.40442 4.00812 2.40807 3.58808C2.41172 3.16804 2.5802 2.76624 2.87723 2.46922C3.17425 2.17219 3.57605 2.00371 3.99609 2.00006C4.41613 1.99641 4.8208 2.15789 5.12294 2.4497L11.531 8.85771C11.8313 9.15813 12 9.56553 12 9.99033C12 10.4151 11.8313 10.8225 11.531 11.1229L5.12294 17.531C4.82252 17.8313 4.41512 18 3.99033 18C3.56553 18 3.15813 17.8313 2.85771 17.531Z"
            :fill="currentPage < totalPage ? '#0694E6' : '#6c737f'"
          />
        </svg>
      </button>
    </div>
    <p class="text-sm text-gray-500">Máx. {{ totalPage }}</p>
  </section>
</template>

<script>
export default {
  name: "pagination",
  props: {
    totalPage: {
      type: Number,
      default: 0,
    },
    currentPage: {
      type: Number,
      default: 1,
    },
  },
  currentPage: {
    deep: true,
    handler(value) {
      this.page = value;
      return value;
    },
  },
  data() {
    return {
      page: 1,
    };
  },
  methods: {
    previousPage() {
      if (this.currentPage > 1) {
        // this.page--;
        this.$emit("changePage", this.currentPage - 1);
      }
    },
    nextPage() {
      if (this.currentPage < this.totalPage) {
        // this.page++;
        this.$emit("changePage", this.currentPage + 1);
      }
    },
  },
};
</script>
